// extracted by mini-css-extract-plugin
export default {"container":"yFTIMAKj","paper":"Aai26lVH","logo":"RwhlrTDV"};